module.exports = __webpack_public_path__ + "assets/img/school-video.f3c8f0dc.png";